import React from 'react';
import Proptypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AdPreview } from '@bingads-webui/ad-library-ad-preview';
import {
  Avatar,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  Text,
  makeStyles,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  cardContainer: {
    width: '358px',
    fontStyle: 'normal',
    '& h3': {
      margin: '0',
    },
    '& .title': {
      ...typographyStyles.body1Strong,
      color: '#242424',
    },
    '& .subtitle': {
      ...typographyStyles.caption1,
      color: '#616161',
    },
  },
  cardPreviewContainer: {
    width: '358px',
    overflow: 'hidden',
    backgroundImage: 'linear-gradient(44.24deg, rgba(66, 62, 55, 0.33) 0%, rgba(241, 238, 230, 0.6) 100%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: '-12px',
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
  },
  linkContainer: {
    width: '114px',
    height: '32px',
    borderRadius: '4px',
    backgroundImage: 'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, #D1D1D1, #D1D1D1)',
    border: '1px solid #D1D1D1',
    padding: `5px 0 ${tokens.spacingVerticalXXS} 0`,
    ...typographyStyles.body1Strong,
    letterSpacing: '0em',
    textAlign: 'center',
    color: '#242424 !important',
  },
});

const getFirstImageDataFromJsonAsset = (assetJson) => {
  const imageData = {};
  const imageAsset = JSON.parse(assetJson)[0];
  imageData.url = imageAsset.AssetUrl;
  imageData.width = imageAsset.Width ? imageAsset.Width : 0;
  imageData.height = imageAsset.Height ? imageAsset.Height : 0;
  return imageData;
};

const AdResultCardComponent = (props) => {
  const {
    AdId: adId,
    AdvertiserName: advertiserName,
    Title: title,
    Description: description,
    DisplayUrl: displayUrl,
    DestinationUrl: destinationUrl,
    AssetJson: assetJson,
    searchConfig,
  } = props;
  const classes = useStyles();

  const adData = {
    shortHeadline: title,
    longHeadline: title,
    description,
    displayUrl,
    url: destinationUrl,
  };

  const imageData = assetJson
    ? getFirstImageDataFromJsonAsset(assetJson)
    : null;

  const adPreviewImage = adData !== null
    ? <AdPreview image={imageData} adData={adData} adId={adId} />
    : null;

  return (
    <Card className={classes.cardContainer}>
      <CardHeader
        image={<Avatar name={`${advertiserName}`} shape="square" color="colorful" />}
        header={<h3 className="title">{`${advertiserName}`}</h3>}
        description={<Text className="subtitle">Advertiser</Text>}
      />
      <div className={classes.cardPreviewContainer}>
        <CardPreview>
          {adPreviewImage}
        </CardPreview>
      </div>
      {
        description && description.length > 16 && (
          <p>{description}</p>
        )
      }
      <CardFooter>
        <Link
          className={classes.linkContainer}
          to={`/ad/${adId}`}
          state={searchConfig}
          aria-label="view ad details"
        >
          View ad details
        </Link>
      </CardFooter>
    </Card>
  );
};

AdResultCardComponent.propTypes = {
  AdId: Proptypes.oneOfType([Proptypes.number, Proptypes.string]).isRequired,
  AdvertiserName: Proptypes.string.isRequired,
  Title: Proptypes.string.isRequired,
  Description: Proptypes.string.isRequired,
  DisplayUrl: Proptypes.string.isRequired,
  DestinationUrl: Proptypes.string.isRequired,
  AssetJson: Proptypes.string.isRequired,
  searchConfig: Proptypes.shape({}),
};

AdResultCardComponent.defaultProps = {
  searchConfig: null,
};

export const AdResultCard = AdResultCardComponent;
